import { render, staticRenderFns } from "./loginBanner.vue?vue&type=template&id=55770420&"
import script from "./loginBanner.vue?vue&type=script&lang=js&"
export * from "./loginBanner.vue?vue&type=script&lang=js&"
import style0 from "./loginBanner.vue?vue&type=style&index=0&id=55770420&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports